import { useEffect, useState } from 'react';
import api from '../services/api';

let cached = null;
let pending = null;

/** The admin's defaults per kind of card (`GET og/templates`). Null until it answers; a picker opens on ring. */
export default function useShareTemplates() {
  const [templates, setTemplates] = useState(cached);
  useEffect(() => {
    if (cached) return undefined;
    let on = true;
    pending = pending || Promise.resolve().then(() => api.get('/og/templates')).then((r) => { cached = r?.data || null; return cached; }).catch(() => { pending = null; return null; });
    pending.then((t) => { if (on && t) setTemplates(t); });
    return () => { on = false; };
  }, []);
  return templates;
}
